export const T = {
  en_GB: {
    startFailed: "Could not start the quiz. Please try again.",
    overrideFailed: "Could not override the quiz. Please try again.",
    overridden: "Quiz marked as passed.",
  },
  nb_NO: {
    startFailed: "Kunne ikke starte quizen. Prøv igjen.",
    overrideFailed: "Kunne ikke overstyre quizen. Prøv igjen.",
    overridden: "Quizen er markert som bestått.",
  },
} as const;
